import Moment from 'moment';

const fromMomentToTimestamp = moment => (moment instanceof Moment ? moment.valueOf() : NaN);

// noinspection JSUnusedGlobalSymbols
export default fromMomentToTimestamp;
